import { create } from "axios";

var axiosInstance = create({});

export default axiosInstance;



// WEBPACK FOOTER //
// ./src/plugins/axios.js